import React from 'react';
import { CheckCircle, Clock, Sparkles, Shield, Home, Banknote } from 'lucide-react';
import { Card } from './ui/card';
import ScrollReveal from './ScrollReveal';

const Benefits = () => {
  const benefits = [
    {
      id: 'fixpreis',
      icon: <Banknote className="w-8 h-8 text-blue-400" />,
      title: 'Fixpreis nach m² oder Fotos',
      description: 'Transparente Preise ohne versteckte Kosten',
      gradient: 'from-blue-500/20 to-cyan-500/20',
      border: 'border-blue-500/30'
    },
    {
      id: 'schnell',
      icon: <Clock className="w-8 h-8 text-purple-400" />,
      title: 'Schnelle Termine möglich',
      description: 'Flexible Terminplanung nach Ihren Wünschen',
      gradient: 'from-purple-500/20 to-pink-500/20',
      border: 'border-purple-500/30'
    },
    {
      id: 'sauber',
      icon: <Sparkles className="w-8 h-8 text-yellow-400" />,
      title: 'Saubere und professionelle Ausführung',
      description: 'Höchste Qualität durch erfahrene Fachkräfte',
      gradient: 'from-yellow-500/20 to-orange-500/20',
      border: 'border-yellow-500/30'
    },
    {
      id: 'hochdeckend',
      icon: <Shield className="w-8 h-8 text-green-400" />,
      title: 'Hochdeckender Weißanstrich',
      description: 'Premium Farben für perfekte Ergebnisse',
      gradient: 'from-green-500/20 to-emerald-500/20',
      border: 'border-green-500/30'
    },
    {
      id: 'wohnungsubergabe',
      icon: <Home className="w-8 h-8 text-indigo-400" />,
      title: 'Ideal für Wohnungsübergabe',
      description: 'Spezialisiert auf Auszug und Einzug',
      gradient: 'from-indigo-500/20 to-blue-500/20',
      border: 'border-indigo-500/30'
    },
    {
      id: 'faire-preise',
      icon: <CheckCircle className="w-8 h-8 text-teal-400" />,
      title: 'Faire Preise in Zürich & Umgebung',
      description: 'Bestes Preis-Leistungs-Verhältnis',
      gradient: 'from-teal-500/20 to-cyan-500/20',
      border: 'border-teal-500/30'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-black via-black to-black relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:64px_64px]"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <ScrollReveal>
          <div className="text-center mb-16">
            <div className="inline-block px-4 py-2 bg-blue-500/10 border border-blue-500/20 rounded-full text-blue-400 text-sm font-medium mb-4">
              Unsere Vorteile
            </div>
            <h2 className="text-4xl md:text-6xl font-bold text-white mb-4">
              Warum Kunden uns wählen
            </h2>
            <p className="text-xl text-slate-400 max-w-2xl mx-auto">
              Professionelle Malerarbeiten mit Fixpreis-Garantie
            </p>
          </div>
        </ScrollReveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {benefits.map((benefit) => (
            <ScrollReveal key={benefit.id} delay={benefits.indexOf(benefit) * 0.1}>
              <Card
                className={`p-8 bg-gradient-to-br ${benefit.gradient} backdrop-blur-xl border ${benefit.border} hover:scale-105 transition-all duration-500 cursor-pointer group relative overflow-hidden`}
              >
                {/* Hover Glow Effect */}
                <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                
                <div className="relative z-10">
                  <div className="mb-6 transform group-hover:scale-110 group-hover:rotate-3 transition-all duration-500">
                    {benefit.icon}
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">
                    {benefit.title}
                  </h3>
                  <p className="text-slate-400">
                    {benefit.description}
                  </p>
                </div>
              </Card>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;